import { inject } from "@angular/core";
import { AuthService } from "./auth.service";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import { Router } from "@angular/router";
import { environment } from "@env/environment";


export const requestInterceptor: HttpInterceptorFn = (req, next) => {
  const isApiRequest = req.url.startsWith(environment.apiBaseUrl) || req.url.startsWith(environment.api);

  if (!isApiRequest) {
    return next(req);
  }

  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  const headers: Record<string, string> = {};

  if (token && !authService.isTokenExpired(token)) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (environment.tenantId) {
    headers[environment.tenantHeaderName] = environment.tenantId;
  }

  if (Object.keys(headers).length > 0) {
    req = req.clone({
      setHeaders: headers
    });
  }

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 && error.status !== 403) {
        return throwError(() => error);
      }

      if (error.status === 401) {
        authService.handleSessionExpired(router.url);
      } else {
        authService.handleUnauthorized(router.url);
      }

      return throwError(() => error);
    })
  );
};
